module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_c/aoj_c-1-4b16944379a25d42f80d423b5eb53af0.jpg";